export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen bg-gradient-to-br from-sky-200 via-sky-100 to-cyan-100 overflow-hidden flex items-center justify-center"
    >
      {/* Soft depth blobs */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full bg-white/10 -translate-x-1/3 -translate-y-1/3 pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full bg-cyan-200/20 translate-x-1/4 translate-y-1/4 pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-sky-300/10 pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-3xl mx-auto px-6 pt-32 pb-24 flex flex-col items-center text-center">

        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/60 backdrop-blur-sm border border-sky-200 rounded-full px-4 py-1.5 mb-7">
          <span className="w-1.5 h-1.5 rounded-full bg-sky-400"></span>
          <span className="text-sky-600 text-xs tracking-widest uppercase font-medium">Eden Prairie, Minnesota</span>
        </div>

        {/* Headline */}
        <h2 className="text-sky-900 font-bold leading-tight mb-5" style={{ fontSize: 'clamp(2.2rem, 5vw, 4rem)' }}>
          A Warm Place<br />
          <span className="text-sky-500">You Can Call Home</span>
        </h2>

        {/* Subheadline */}
        <p className="text-sky-800/70 text-base md:text-lg leading-relaxed mb-10 max-w-2xl">
          At Pure Care Assisted Living, we provide personalized, dignified care for seniors in a cozy, family-style home — because every resident deserves to feel loved, safe, and at home.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <button
            onClick={() => scrollTo('contact')}
            className="px-8 py-3 rounded-full bg-sky-500 text-white text-sm font-semibold hover:bg-sky-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            Schedule a Visit
          </button>
          <button
            onClick={() => scrollTo('services')}
            className="px-8 py-3 rounded-full border border-sky-300 text-sky-600 text-sm font-medium hover:bg-sky-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Our Services
          </button>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-8">
          {[
            { icon: 'ri-shield-check-line', label: 'Licensed & Certified' },
            { icon: 'ri-heart-line', label: 'Personalized Care Plans' },
            { icon: 'ri-team-line', label: '24/7 Dedicated Staff' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-sky-700/80">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-sky-500 text-base`}></i>
              </div>
              <span className="text-sm whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>

      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50 text-sm"></i>
        </div>
      </div>
    </section>
  );
}
